// Import both implementations
import * as localDataService from './dataService';
import * as apiDataService from './apiDataService';

// This wrapper allows us to switch between localStorage and API-based storage
// Set USE_API to true to use the backend API, false for localStorage

const USE_API = true; // Set to true to use backend API

// Since the API service is async but localStorage is sync, we need to wrap the localStorage
// functions to make them async for consistency
const wrapAsync = (fn) => {
  return async (...args) => {
    return Promise.resolve(fn(...args));
  };
};

// If using localStorage, wrap functions to be async
const wrappedLocalDataService = USE_API ? {} : {
  ...localDataService,
  getMyRequests: wrapAsync(localDataService.getMyRequests),
  getRequestById: wrapAsync(localDataService.getRequestById),
  createRequest: wrapAsync(localDataService.createRequest),
  updateRequestStatus: wrapAsync(localDataService.updateRequestStatus),
  deleteRequest: wrapAsync(localDataService.deleteRequest),
  getAllRequests: wrapAsync(localDataService.getAllRequests),
  getRequestStats: wrapAsync(localDataService.getRequestStats),
  addCommentToRequest: wrapAsync(localDataService.addCommentToRequest),
};

// Export the appropriate implementation
const dataService = USE_API ? apiDataService : wrappedLocalDataService;

export const {
  RequestStatus,
  getMyRequests,
  getRequestById,
  createRequest,
  updateRequestStatus,
  updateRequest,
  deleteRequest,
  getAllRequests,
  getRequestStats,
  addCommentToRequest
} = dataService;

// For components that need to know if we're using API
export const isUsingAPI = () => USE_API;